import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { QRCodeCanvas } from "qrcode.react";
import { CheckCircle2, Loader2, Calendar } from "lucide-react";
import api from "@/lib/api";
import { formatDate } from "@/components/EventCard";
import { Logo } from "@/components/Logo";

export default function TicketConfirmation() {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    api.get(`/tickets/order/${orderId}`).then((r) => setOrder(r.data)).catch(() => {});
  }, [orderId]);

  if (!order) return <div className="min-h-[60vh] flex items-center justify-center"><Loader2 className="animate-spin text-[#e0481f]" /></div>;

  return (
    <div className="max-w-2xl mx-auto px-5 py-12">
      <div className="text-center mb-8">
        <CheckCircle2 className="mx-auto text-[#4ade80] mb-3" size={56} />
        <h1 className="headline text-4xl text-[#f7f3ec]">You're In!</h1>
        <p className="text-[#a9a196]">Confirmation sent to {order.customer_email}</p>
      </div>

      {order.tickets.map((t, i) => (
        <div key={t.code} className="card-warm rounded-2xl overflow-hidden mb-5" data-testid={`ticket-${i}`}>
          <div className="bg-[#0f0e0d] px-6 py-4 flex items-center justify-between border-b border-[#d4af37]/15">
            <Logo className="h-10" />
            <span className="headline text-lg gold-text">I-65 RYDERS</span>
          </div>
          <div className="p-6 flex flex-col sm:flex-row gap-6 items-center">
            <div className="bg-white p-3 rounded-xl">
              <QRCodeCanvas value={t.code} size={128} />
            </div>
            <div className="flex-1 text-center sm:text-left">
              <h3 className="headline text-2xl text-[#f7f3ec]">{order.event_title}</h3>
              <p className="text-[#d4af37]">{order.ticket_type}</p>
              <p className="text-[#a9a196] text-sm flex items-center gap-1.5 justify-center sm:justify-start mt-1"><Calendar size={14} /> Ticket {i + 1} of {order.quantity}</p>
              <p className="mt-3 font-mono text-sm text-[#f3c649] tracking-wider">{t.code}</p>
              <span className={`inline-block mt-2 text-xs font-display uppercase tracking-wider px-2.5 py-1 rounded-full ${t.checked_in ? "bg-[#4ade80]/20 text-[#4ade80]" : "bg-[#d4af37]/15 text-[#d4af37]"}`}>
                {t.checked_in ? "Checked In" : "Valid • Ready to Scan"}
              </span>
            </div>
          </div>
        </div>
      ))}

      {order.member_nickname && (
        <p className="text-center text-sm text-[#8f857a] mb-6">Purchase credited to Ryder <span className="text-[#d4af37]">{order.member_nickname}</span></p>
      )}
      <div className="text-center">
        <Link to="/events" className="btn-outline-cream rounded-full px-6 py-3 font-display uppercase tracking-wide inline-block">Browse More Events</Link>
      </div>
    </div>
  );
}
